import gql from 'graphql-tag';

const getRoutesWithStatusQuery = gql`
query {
  routes {
    name
    routeCode
    polyline
    location{
      name
    }
    routeStatuses {
      status
      subStatus
    }
    ports {
      name
      portCode
      order
      latitude
      longitude
      isFreight
      hideOnMap
    }
    status
    isFreight
    hideOnMap
    isStatusChangeUpcoming
  }
}
`;

const getRouteInformationQuery = gql`
query 
(
  $originPortName: String
  $destinationPortName: String
) {
  routes 
  (
    where: {
      and: [
          { originPort: {name: { eq: $originPortName } } }
          { destinationPort: {name: { eq: $destinationPortName } } }
      ]
    }
  ) {
    name
    routeInformation
    polyline
    location {
      name
    }
    ports {
      name
      portCode
      order
      latitude
      longitude
      isFreight
      hideOnMap
    }
    isFreight
    hideOnMap
  }
}
`;

const getRouteInformationByPortsQuery = gql`
query 
(
  $originPortName: String
  $destinationPortName: String
) {
  routes 
  (
    where: {
      ports: { some: { name: { contains: $originPortName} } }
      and: { ports: { some: { name: { contains: $destinationPortName} } } }
    }
  ) {
    routeCode
    name
    routeInformation
    polyline
    location {
      name
    }
    ports {
      name
      portCode
      order
      latitude
      longitude
    }
    isTimetableWarningEnabled
    timetableWarningType
    timetableTitle
    timetableText
    routeInformationLinkText
    timetableServiceStatusLinkText
  }
}
`;

const getAllRoutesMapCoordsQuery = gql`
query {
  routes {
    name
    routeCode
    polyline
    ports{
      portCode
      longitude
      latitude
      name
      portImage
      isFreight
      hideOnMap
    }
    location {
      name
      latitude
      longitude
      locationCode
      locationImage
      isFreight
      hideOnMap
    }
    originPort{
      name
      portCode
      isFreight
      hideOnMap
    }
    destinationPort{
      name
      portCode
      isFreight
      hideOnMap
    },
  }
}
`;

const getRoutesServedByRouteCodeQuery = gql`
query 
(
  $routeCode: String
) {
  routes (where: {routeCode: {eq: $routeCode}})
  {
    description
    routeCode
    name
    keyInformation
    polyline
    vessels{
      name
      vesselUrl
      vesselCode
    }
    ports{
      name
      portCode
      portUrl
      longitude
      latitude
      location{
        name
      }
    }
  }
}
`;

const getRouteMapByRouteCode = gql`
query 
(
  $routeCode: String
) {
  routes (where: {routeCode: {eq: $routeCode}})
  {
    name
    routeCode
    polyline
    ports{
      name
      portCode
      longitude
      latitude
    }
  }
}
`;

const getAllRoutesQuery = gql`
query 
{
  routes 
  {
    id
    routeCode
    textCode
    name
    routeInformation
    polyline
    location {
      name
    }
    ports {
      name
      portCode
      order
      latitude
      longitude
    }
  }
}
`;

export {
  getRoutesWithStatusQuery,
  getRouteInformationQuery,
  getRouteInformationByPortsQuery,
  getAllRoutesMapCoordsQuery,
  getRoutesServedByRouteCodeQuery,
  getRouteMapByRouteCode,
  getAllRoutesQuery,
};
